<div class="faq-hero" #faqHero data-section-id="faq-hero-section" data-section-name="FAQ Hero">
  <div class="faq-hero__content ocultarMobile">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner4-faq-xl.png" alt="Beneficios Unipay"
      class="faq-hero__image ocultarMobile" />
  </div>
  <div class="faq-hero__content ocultarDesktop">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner4-faq-movil.png"
      alt="FAQ Unipay" class="faq-hero__image" />
  </div>
</div>
